const setUpOverlayListeners = () => {
    $(".js-overlay-close").on("click", function () {
        $(this).closest(".js-overlay").css("display", "none");
    });
};

const initializeListeners = () => {
    setUpOverlayListeners();
};

export default initializeListeners;
